// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root___U_OA","inputWrap":"Table_inputWrap__1zHHB","col":"Table_col__1b8Fg","bmiTooltip":"Table_bmiTooltip__nl6xa"};